<mat-form-field appearance="outline" class="search-bar">
  <mat-label>WTF is ...</mat-label>
  <input matInput (keydown.enter)="onEnter()"  [(ngModel)]="search" ngDefaultControl>
  <mat-icon matSuffix>search</mat-icon>
</mat-form-field>
